import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import { FeatureProvider } from '@exp/features';
import { connectWindowTests } from '@exp/redux/TestSlice';

import { store } from '../redux/store';
import Router from '../js/config/router';

connectWindowTests(store);

const root = createRoot(document.getElementById('root'));
root.render((
  <FeatureProvider appName="store-web--shop">
    <Provider store={store}>
      <Router />
    </Provider>
  </FeatureProvider>
));
